<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn :to="'/content/' + contentData.url + '/' + sectionData.url" color="error" icon flat exact>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline primary--text">{{taskData.name}}</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-2" xs12 md10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <r-reading-task v-if="taskData.type == 'Reading'"></r-reading-task>
      <r-lecture-task v-if="taskData.type == 'Lecture'"></r-lecture-task>
      <r-test-task v-if="taskData.type == 'Practice' || taskData.type == 'NCLEX'"></r-test-task>
      <r-linked-task v-if="taskData.type == 'Linking'"></r-linked-task>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import ReadingTask from './ReadingTask.vue'
import LectureTask from './LectureTask.vue'
import TestTask from './TestTask.vue'
import LinkedTask from './LinkedTask.vue'
export default {
  components: {
    rCrumbs: Crumbs,
    rReadingTask: ReadingTask,
    rLectureTask: LectureTask,
    rTestTask: TestTask,
    rLinkedTask: LinkedTask
  },
  data: () => ({
    loading: false,
    tab: null,
    contentData: {},
    sectionData: {},
    taskData: {}
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      for (let s of this.$store.getters.sectionByContent(this.contentData.key)) {
        if (s.url === this.$route.params.sectionUrl) this.sectionData = s
      }
      for (let t of this.$store.getters.taskBySection(this.sectionData.key)) {
        if (t.url === this.$route.params.taskUrl) this.taskData = t
      }
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/ManageTask.vue